import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import axios from "axios";
const [
  GET_LIST,
  CREATE,
  UPDATE,
  UPDATE_MANY,
  DELETE,
  DELETE_MANY,
  GET_MANY_REFERENCE,
  GET_ONE,
] = [
    "GET_LIST",
    "CREATE",
    "UPDATE",
    "UPDATE_MANY",
    "DELETE",
    "DELETE_MANY",
    "GET_MANY_REFERENCE",
    "GET_ONE",
  ];
let toSearch = {};

const new_fetch = async (url, options, trying = 0) => {
  return new Promise((resolve, reject) => {
    // let trying = 0;
    fetch(url, options)
      .then((res) => {
        //
        //
        //
        if ((res.status === 500 && trying === 0) || (res.status == 401 && trying === 0)) {
          trying = 1;
          axios
            .post(
              "https://securetoken.googleapis.com/v1/token?key=AIzaSyDKUGHP_aDi--W8prH3CtQIOc2cjkh3FRc",
              {
                grant_type: "refresh_token",
                refresh_token: localStorage.RT,
              }
            )
            .then((resrefresh) => {
              //
              localStorage.setItem("auth", resrefresh.data.access_token);
              localStorage.setItem("RT", resrefresh.data.refresh_token);
              resolve(
                new_fetch(url, {
                  ...options,
                  headers: {
                    ...options.headers,
                    Authorization: `Bearer ${resrefresh.data.access_token}`,
                  },
                }, trying)
              );
            })
            .catch((err) => {
              resolve(res);
            });
        } else {
          resolve(res);
        }
      })
      .catch((err) => {
        //
        reject(err);
      });
  });
};
const lb4Provider = (
  apiUrl,
  headers = (headers) => {
    return {
      ...headers,
      Authorization: `Bearer ${localStorage.getItem("auth")}`,
    };
  },
  idParamApi = "_id",
  idParamAdmin = "id",
  ftch = new_fetch
) => {
  const getOptions = async (type, body) => {
    // //
    const options = {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("auth")}`,
      },
    };
    if (body) {
      if (type === CREATE) {
        let id = uuidv4();
        body["id"] = id;
        body["_id"] = id;
      }
      //
      options.body = JSON.stringify(body);
      options.headers["Content-Type"] = "application/json";
    }
    switch (type) {
      case CREATE:
        options.method = "POST";
        break;

      case UPDATE:
      case UPDATE_MANY:
        options.method = "PATCH";
        break;
      case DELETE:
      case DELETE_MANY:
        options.method = "DELETE";
        break;
      default:
        options.method = "GET";
        options.headers["Authorization"] = `Bearer ${localStorage.getItem(
          "auth"
        )}`;
    }
    return options;
  };

  const setWhere = (url, filter, initKey = "filter[where]") => {
    for (const [key, value] of Object.entries(filter)) {


      if (key.toString().includes("function")) {
        delete filter[key]
      }
      else {


        let filter_date = []
        let flag_date = false
        let key_to_use = key;
        let operator = null;

        if (key.includes("_gt")) {

          key_to_use = key.split("_gt")[0];
          if (key_to_use == "date") {
            flag_date = true
            if (filter["and"]) {
              filter["and"] = filter["and"].concat({ "date": { "gt": new Date(value).toISOString() } })
            }
            else {
              filter["and"] = [{ "date": { "gt": new Date(value).toISOString() } }]
            }
            filter_date = filter_date.concat({ $gte: new Date(value).toISOString() })
          }
          operator = "$gt";
        }

        if (key.includes("_lt")) {
          key_to_use = key.split("_lt")[0];
          if (key_to_use == "date") {
            flag_date = true
            if (filter["and"]) {
              filter["and"] = filter["and"].concat({ "date": { "lt": new Date(value).toISOString() } })
            }
            else {
              filter["and"] = [{ "date": { "lt": new Date(value).toISOString() } }]
            }
            filter_date = filter_date.concat({ $lt: new Date(value).toISOString() })

          }
          operator = "$lt";
        }

        if (typeof filter[key] === "string") {
          //ON TEST SI ON FILTRE PAR DATE
          //
          //
          if (key_to_use == "date") {
            //

            // filter[key_to_use] = {"$and" : filter_date}
            //
            //
            //
          } else {
            filter[key] = { "like": value };
          }
        } else {
          if (typeof filter[key] === "boolean") {
            filter[key] = value;
          } else {
            if (typeof filter[key] === "object") {

              if (key === "_id") {
                delete filter[key];
              } else {
                if (key == "projet_vente") {
                  filter[key] = { "$in": value }
                }
                else {
                  filter[key] = value
                }
              }
            } else {
              filter[key] = value;

            }
          }
        }
        if (key !== key_to_use) {

          delete filter[key];
          //
        }
      }

    }


    toSearch = { ...toSearch, where: filter };
    // //
    // //
  };

  const fetchTotal = async (resource, filter) => {
    // //
    // //
    const url = new URL(apiUrl);
    const path = url.pathname.split("/");
    path.push(resource, "count");
    if (filter && Object.keys(filter).length > 0) {

      setWhere(url, filter, "where");
    }
    // //
    url.pathname = path.filter(Boolean).join("/");
    return (await (await ftch(url.toString(), await getOptions())).json())
      .count;
  };

  const setLimitAndOffset = (url, { page = 1, perPage = 10 }) => {
    // //
    // const search = url.searchParams;
    // search.append("filter", `{"limit":${ perPage + ""}}`);
    // search.append("filter", `{"offset":${(page - 1) * perPage + ""}}`);

    toSearch = {
      ...toSearch,
      limit: perPage + "",
      skip: (page - 1) * perPage + "",
    };
    // search.append("filter[limit]", perPage + "");
    // search.append("filter[offset]", (page - 1) * perPage + "");
    // //
  };

  const setOrder = (url, { field = "createdAt", order = "DESC" }) => {
    // //
    const search = url.searchParams;

    // search.append("filter[order]", `${field} ${order}`);
    toSearch = { ...toSearch, order: `${field} ${order}` };

    // //
    search.append("filter", `${JSON.stringify(toSearch)}`);
  };

  const mapKeys = (obj) =>
    _.mapKeys(obj, (value, key) => {
      if (key === idParamApi) return idParamAdmin;
      return key;
    });

  const fn = async (
    type,
    resource,
    { pagination, sort, filter = {}, data, ids, id, target }
  ) => {
    // //
    let total = null;
    // //
    if ([GET_LIST, GET_MANY_REFERENCE].indexOf(type) > -1) {
      // //
      const totalFilter = JSON.parse(JSON.stringify(filter));
      // //
      if (id) totalFilter[target || idParamApi] = id;
      total = await
        fetchTotal(resource, totalFilter);
    }

    const url = new URL(apiUrl);

    const path = url.pathname.split("/");
    path.push(resource);
    if (id && !target) path.push(id);

    if (id && target) filter[target] = id;
    if (ids) {
      if (type === DELETE_MANY) {
        const r = [];
        for (let id of ids) {
          r.push((await fn(DELETE, resource, { id })).data);
        }
        return { data: r.map((el) => el[idParamAdmin]) };
      }
      _.set(filter, `${idParamApi}.inq`, ids);
    }
    if (filter && Object.keys(filter).length > 0) {
      // //
      // //
      if ([UPDATE_MANY].indexOf(type) > -1) setWhere(url, filter, "where");
      else setWhere(url, filter);
    }

    if (pagination) setLimitAndOffset(url, pagination);
    if (sort) setOrder(url, sort);

    const options = await getOptions(type, data);
    //
    let item;
    if ([DELETE].indexOf(type) > -1) item = await fn(GET_ONE, resource, { id });
    url.pathname = path.filter(Boolean).join("/");
    let response = await ftch(url.toString(), options);
    try {
      response = await response.json();
    } catch (e) {
      if ([DELETE].indexOf(type) === -1) {
        if (id) return await fn(GET_ONE, resource, { id });
        throw e;
      }
    }
    if (response.error) throw new Error(response.error.message);
    let result = {};
    if ([UPDATE_MANY, DELETE_MANY].indexOf(type) > -1) result.data = ids;
    else if ([DELETE].indexOf(type) > -1) result = item;
    else
      result.data = Array.isArray(response)
        ? response.map(mapKeys)
        : mapKeys(response);

    if (typeof total === "number") result.total = total;

    return result;
  };

  return fn;
};

export default lb4Provider;
